<template>
  <AbsPopup id="PointBuyCancel" :title="getTitle" @close="$emit('close')" @submit="submit" :initButtonList="buttonList">
    <template #body>
      <div class="popup-body">
        <div>
          <li>
            <div>
              <span>작가필명</span>
            </div>
            <div class="box mar">
              <span>{{ $store.getters.nic }}</span>
            </div>
          </li>
          <li>
            <div>
              <span>작가실명</span>
            </div>
            <UInput type="text" placeholder="" v-model="username" @focusout="focusHandler" />
          </li>
        </div>
        <div>
          <li>
            <div>
              <span>취소금액</span>
            </div>
            <div class="box">
              <span>{{ getPrice }}</span>
            </div>
          </li>
        </div>
        <div>
          <li>
            <div>
              <span>{{ '취소사유' }}</span>
            </div>
            <div>
              <span class="right">공백포함 {{ textSize }} / {{ total }}</span>
            </div>
          </li>
        </div>
        <UInput type="textarea" :limitHeight="150" placeholder="내용을 입력해 주세요" v-model="message" :auto="true" :limit="count" @enter="inputSubmit" @esc="cancel"/>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'

export default {
  props: {
    option: {
      type: Object
    }
  },
  mounted () {
    // document.querySelector('.popup-body input').focus()
    this.$emit('loading', false)
  },
  data: () => {
    return {
      username: '',
      message: '',
      count: 300
    }
  },
  name: 'PointBuyCancel',
  watch: {
  },
  computed: {
    type () {
      return this.option.param.type
    },
    getPrice () {
      console.log(this.option)
      return this.option.param.data.price
    },
    getTitle () {
      switch (this.type) {
        case 'point' :
          return ''
        default :
          return '결재취소하기'
      }
    },
    buttonList () {
      return [
        {name: '닫기', state: 'deactive', click: () => { this.$emit('close') }},
        {name: '결재취소', state: this.isSubmit, click: this.submit}
      ]
    },
    isSubmit () {
      if (this.username !== '' && this.message !== '') {
        return 'active'
      } else {
        return 'disable'
      }
    },
    textSize () {
      return this.message.length
    },
    total () {
      return (this.count === undefined) ? 30 : this.count
    }
  },
  methods: {
    focusHandler () {

    },
    cancel () {

    },
    inputSubmit () {

    },
    submit () {
      this.$http.post('/api/point/buyCancel', {merchant: this.option.param.data.merchant, name: this.username, reason: this.message}).then((e) => {
        console.log(e)
        if (e.success) {
          this.$store.commit('chargePoint', this.$store.getters.chargePoint + this.cash)
          this.$emit('submit', {type: this.status, cash: this.cash})
        }
      })
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
.popup-body {
  margin: 10px 10px;
  width: 450px;
  text-align: left;
  line-height: 30px;
  margin: 15px;
}
.popup-body > div {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 10px;
}
.popup-body > div > li {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.popup-body > div > li > div {
  display: flex;
  flex-direction: row;
}
.popup-body > div > li > div:first-child {
  width: 70px;
}
.popup-body > div > li > div:last-child {
  flex: 1;
  justify-content: center;
}
.popup-body > div > li > .box {
  background-color: var(--disable);
}
.popup-body > div > li > .box.mar {
  margin-right: 15px;
}
.popup-body .input {
  border: 1px solid var(--disable);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/PointBuyCancel.vue